import {
  Component,
  OnInit,
  OnDestroy
} from '@angular/core';

import {
  ActivatedRoute,
  Router,
  NavigationEnd
} from '@angular/router';

import {
  Subscription
} from 'rxjs';

import {
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';

import {
  QuestionnaireService
} from '@shared/services/questionnaire.service';
import {
  CrudOperationsService
} from '@app/shared/components/cell-renderers/crud-operations-renderer/crud-operations.service';

import {
  CrudOperationsRendererComponent
} from '@shared/components/cell-renderers/crud-operations-renderer/crud-operations-renderer.component';
import {
  AnswerSetDialogComponent
} from '@shared/components/dialogs/answer-set-dialog/answer-set-dialog.component';
import { HeaderItem } from '@app/shared/components/header/header';
import { HeaderService } from '@app/shared/components/header/header.service';
import { ClientHeaderDetailsComponent } from './client-header-details/client-header-details.component';
@Component({
  selector: 'db-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit, OnDestroy {
  headerTitle: string;
  headerItems: HeaderItem;
  dataGridConfig;
  rowData: any;
  clientId: string;
  answerSetDialogRef: MatDialogRef<AnswerSetDialogComponent>;
  subscriptionManager = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private questionnaireService: QuestionnaireService,
    private headerService: HeaderService,
    private crudOperationsService: CrudOperationsService
  ) {

    const navigationSubscription = this.router
      .events
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.initializePageAndRowData();
        }
      });

    const editOperationSubscription = this.crudOperationsService
      .editOperation$
      .subscribe(params => {
        this.editOperation(params);
      });

    const cloneOperationSubscription = this.crudOperationsService
      .cloneOperation$
      .subscribe(params => {
        this.cloneOperation(params);
      });

    this.subscriptionManager
      .add(navigationSubscription)
      .add(editOperationSubscription)
      .add(cloneOperationSubscription)
  }

  ngOnInit() {
    this.clientId = this.route.snapshot.paramMap.get('clientId');

    this.initializePageAndRowData();

      this.dataGridConfig = {
        columnDefs: [
          {
            headerName: 'Answer Set',
            field: 'title',
            minWidth: 150
          },
          {
            headerName: 'Questionnaire',
            field: 'id',
            minWidth: 150
          },
          {
            headerName: 'Created By',
            field: 'createdBy',
            minWidth: 150
          },
          {
            headerName: 'Modified By',
            field: 'modifiedBy',
            minWidth: 150
          },
          {
            headerName: 'Created',
            field: 'createdDate',
            minWidth: 150
          },
          {
            headerName: 'Modified',
            field: 'modifiedDate',
            minWidth: 150
          },
          {
            headerName: '',
            field: 'id',
            cellRenderer: 'crudOperationsRenderer',
            cellRendererParams: {
              answerSetRouterLink: '/answer-set',
              operations: {
                edit: {
                  label: 'Edit'
                },
                clone: {
                  label: 'Clone'
                },
              }
            },
            minWidth: 150,
            suppressSorting: true,
            suppressFilter: true
          }
        ],
        frameworkComponents: {
          crudOperationsRenderer: CrudOperationsRendererComponent
        }
      };
  }

  initializePageAndRowData() {
    this.clientId = this.route.snapshot.paramMap.get('clientId');

    if (this.clientId.length) {
      this.questionnaireService.getAnswerSets(this.clientId)
        .subscribe(data => {
          this.rowData = data;
        });

      this.questionnaireService.getClient(this.clientId)
        .subscribe(data => {
          this.headerTitle = data.clientFullName + ' - ' + data.can;
        });

      this.inititializeHeaderItem();    
    }
  }

  inititializeHeaderItem() {
    const data = {
      clientId: this.clientId,
      answerSetName: "this.answerSetName",
      questionnaireName: "this.questionnaireName",
    };

    this.configureHeaderItems();

    this.headerItems.data = data;
    this.headerService.configureHeaderItems(this.headerItems);
  }

  configureHeaderItems() {
    this.headerItems = new HeaderItem(ClientHeaderDetailsComponent, {});
  }

  editOperation(params) {
    this.router.navigate([params.answerSetRouterLink, params.value]);
  }

  cloneOperation(params) {
    this.answerSetDialogRef = this.dialog.open(AnswerSetDialogComponent, {
      width: '500px',
      panelClass: 'db-dialog',
      data: {
        params: params,
        dialogTitle: 'Clone Answer Set',
        submitButtonLabel: 'Clone Answer Set',
        submitButtonTypeClass: 'button--primary'
      }
    });

    this.answerSetDialogRef.afterClosed()
      .subscribe(([answerSetFormValue]) => {
        if (!answerSetFormValue) {
          return;
        }
        const answerSetFormData = JSON.parse(answerSetFormValue);
        
        this.questionnaireService
          .addAnswerSet(answerSetFormData, this.clientId)
          .subscribe(() => {
            this.initializePageAndRowData();
          });
      });
  }

  answerSetOperation() {
    this.answerSetDialogRef = this.dialog.open(AnswerSetDialogComponent, {
      width: '500px',
      panelClass: 'db-dialog',
      data: {
        clientId: this.clientId,
        dialogTitle: 'New Answer Set',
        submitButtonLabel: 'Add Answer Set',
        submitButtonTypeClass: 'button--accent',
      }
    });

    this.answerSetDialogRef.afterClosed()
      .subscribe(([answerSetFormValue]) => {
        if (!answerSetFormValue) {
          return;
        }
        
        const answerSetFormData = JSON.parse(answerSetFormValue);

        this.questionnaireService
          .addAnswerSet(answerSetFormData, this.clientId)
          .subscribe(() => {
            this.initializePageAndRowData();
          });
      });
  }

  ngOnDestroy() {
    this.subscriptionManager.unsubscribe();
  }
}
